<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ title }}</h2>
        <div class="sf-card__tools">
          <v-text-field class="sf-search sf-table-card__search"
                        clearable
                        dense
                        flat
                        hide-details
                        prepend-inner-icon="ti-search"
                        solo
                        v-bind:placeholder="$t('search')"
                        v-if="!hideSearch"
                        v-model="search" />
          <slot name="filter"> </slot>
          <slot name="actions"> </slot>
          <v-btn color="primary"
                 depressed
                 v-bind:to="{ name: itemAddRouteName }"
                 v-if="itemAddRouteName != null">
            <v-icon left>ti-plus</v-icon>
            {{ $t('add') }}
          </v-btn>
        </div>
      </div>
      <div class="sf-card__tabs"
           v-if="filter != null">
        <v-tabs class="sf-tabs"
                show-arrows
                v-model="activeFilterValue">
          <v-tab v-bind:key="value.name"
                 v-for="value in filter.values">
            <v-icon left
                    small
                    v-if="value.icon != null">
              {{ value.icon }}
            </v-icon>
            {{ value.title }}
            <v-chip class="ml-2 sf-pill sf-pill--neutral"
                    x-small>
              {{ itemCountForFilterValue(value.name) }}
            </v-chip>
          </v-tab>
        </v-tabs>
      </div>
      <v-progress-linear color="accent"
                         indeterminate
                         v-bind:active="loading" />
      <v-data-table v-bind:class="{ 'sf-table--clickable': itemRouteName != null }"
                    v-bind:footer-props="{ itemsPerPageOptions: [ 15, 30, 50, 100, -1 ] }"
                    v-bind:headers="headers"
                    v-bind:items="filteredItems"
                    v-bind:items-per-page="itemsPerPage"
                    v-bind:no-data-text="$t('noItemsWereFound')"
                    v-bind:no-results-text="$t('noItemsWereFound')"
                    v-bind:search="search"
                    v-bind:sort-by="sortBy"
                    v-on:click:row="openItem">
        <!-- Zellen-Slots (item.<spalte>) an die Tabelle durchreichen -->
        <template v-for="name in cellSlotNames"
                  v-slot:[name]="scope">
          <slot v-bind="scope"
                v-bind:name="name" />
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  export default {
    computed: {
      cellSlotNames() {
        return Object.keys(this.$scopedSlots).filter(name => name.startsWith('item.'))
      },
      filteredItems() {
        let items = this.items

        if (this.filter != null && this.activeFilterValue != null) {
          const activeFilterValue = this.filter.values[this.activeFilterValue]

          if (activeFilterValue != null && !activeFilterValue.showAll) {
            if (activeFilterValue.name === 'on-site') {
              items = items.filter(i => i.wasAttending)
            } else {
              items = items.filter(i => i.state === activeFilterValue.name)
            }
          }
        }

        return items
      }
    },
    data: () => ({
      activeFilterValue: null,
      search: null
    }),
    methods: {
      itemCountForFilterValue(name) {
        const filterValue = this.filter.values.find(v => v.name === name)

        if (filterValue == null || filterValue.showAll) {
          return this.items.length
        }

        if (name === 'on-site') {
          return this.items.filter(i => i.wasAttending).length
        }

        return this.items.filter(i => i.state === name).length
      },
      openItem(item) {
        this.$emit('click:row', item)

        if (this.itemRouteName != null) {
          this.$router.push({ name: this.itemRouteName, params: { id: item.id } })
        }
      }
    },
    name: 'DataTableCard',
    props: {
      filter: Object,
      headers: Array,
      hideSearch: Boolean,
      itemAddRouteName: String,
      itemRouteName: String,
      items: Array,
      itemsPerPage: {
        default: 30,
        type: Number
      },
      loading: Boolean,
      sortBy: [ String, Array ],
      title: String
    }
  }
</script>

<style scoped>
  .sf-table-card__search {
    flex: 1 1 200px;
    max-width: 320px;
  }

  .sf-table--clickable >>> tbody tr:not(.v-data-table__empty-wrapper) {
    cursor: pointer;
  }
</style>

<i18n>
  {
    "de": {
      "add": "Hinzufügen",
      "noItemsWereFound": "Es sind keine Einträge vorhanden.",
      "search": "Suchen"
    },
    "en": {
      "add": "Add",
      "noItemsWereFound": "No items were found.",
      "search": "Search"
    }
  }
</i18n>
